import { render, staticRenderFns } from "./date-revision-field.vue?vue&type=template&id=e33252e2&scoped=true"
import script from "./date-revision-field.vue?vue&type=script&lang=js"
export * from "./date-revision-field.vue?vue&type=script&lang=js"
import style0 from "./date-revision-field.vue?vue&type=style&index=0&id=e33252e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33252e2",
  null
  
)

export default component.exports